module.exports = __webpack_public_path__ + "static/img/logo-header.8f6825e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-header.png
// module id = x9ub
// module chunks = 5